import { useState, useEffect, useCallback } from 'react';

const navItems = [
  { label: '首页', href: '#hero' },
  { label: '深扒图文', href: '#cards' },
  { label: '瓜友热评', href: '#comments' },
  { label: '常见问答', href: '#faq' },
  { label: '吃瓜热榜', href: '#ranking' },
  { label: '热门话题', href: '#topics' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleNavClick = useCallback((href: string) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <a
            href="#hero"
            onClick={(e) => {
              e.preventDefault();
              handleNavClick('#hero');
            }}
            className="flex items-center gap-2 cursor-pointer"
          >
            <span className={`font-heading text-2xl whitespace-nowrap transition-colors duration-300 ${scrolled ? 'text-primary-500' : 'text-background-50'}`}>
              51吃瓜大赛
            </span>
          </a>

          <nav className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick(item.href);
                }}
                className={`px-3 py-2 text-sm font-medium rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer ${
                  scrolled
                    ? 'text-foreground-700 hover:text-primary-500 hover:bg-primary-50'
                    : 'text-background-50/90 hover:text-background-50 hover:bg-background-50/15'
                }`}
              >
                {item.label}
              </a>
            ))}
          </nav>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg cursor-pointer transition-colors ${
              scrolled
                ? 'text-foreground-700 hover:bg-background-100'
                : 'text-background-50 hover:bg-background-50/15'
            }`}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/60">
          <nav className="px-4 py-3 flex flex-col gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick(item.href);
                }}
                className="px-3 py-3 text-sm font-medium text-foreground-700 hover:text-primary-500 hover:bg-primary-50 rounded-lg transition-colors duration-200 cursor-pointer whitespace-nowrap"
              >
                {item.label}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}